module.exports = __webpack_public_path__ + "img/projectList_bg4.cb850382.png";